export const stores = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.4731307580246, 54.76939139484175],
      },
      properties: {
        name: 'Camerons Ballymena',
        address: '23-29 Broughshane St, Ballymena, Co. Antrim, Antrim BT43 6EB',
        phone: '0044 2825648821, 00447710557787',
        phoneFormatted: '+44  2825648821, +44 7710557787',
        website: 'www.cameronsballymena.com',
        county: 'Antrim',
        postcode: 'BT43 6EB',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.4953939544992085, 54.799928179778234],
      },
      properties: {
        name: 'CFC Interiors',
        address: 'Longwood Rd, Newtownabbey, Co. Antrim, Antrim BT37 9UL',
        phone: '0044 2890854374',
        phoneFormatted: '+44  2890854374',
        website: 'www.beds.ie',
        county: 'Antrim',
        postcode: 'BT37 9UL',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.495718587376461, 54.77219617824987],
      },
      properties: {
        name: 'Dougans',
        address: 'Ahoghill, Portglenone, Co. Antrim, Antrim BT42 1LE',
        phone: '0044 2825871397',
        phoneFormatted: '+44  2825871397',
        website: '',
        county: 'Antrim',
        postcode: 'BT42 1LE',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.90636254400039, 54.565524615906114],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Drumkeen Retail Park, Bradford Court, Belfast, Co Antrim, Antrim BT8 6RD',
        phone: '0044 28640833',
        phoneFormatted: '+44  28640833',
        website: 'www.harrycorry.com',
        county: 'Antrim',
        postcode: 'BT8 6RD',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.977590286327198, 54.577217453606586],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Westwood Retail Park, Andersonstown Road, Belfast, Co Antrim, Antrim BT11 9BQ',
        phone: '0044 28606790',
        phoneFormatted: '+44  28606790',
        website: 'www.harrycorry.com',
        county: 'Antrim',
        postcode: 'BT11 9BQ',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.924943917014233, 54.66135849697364],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          '3 Valley Retail Park, 3 Church Road, Co Antrim, Antrim BT36 7LP',
        phone: '0044 2890364968',
        phoneFormatted: '+44  2890364968',
        website: 'www.harrycorry.com',
        county: 'Antrim',
        postcode: 'BT36 7LP',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.94885698818038, 54.60409730372336],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address: '190 Shankill Road, Belfast, Co Antrim, Antrim BT13 2BH',
        phone: '0044 2890230938',
        phoneFormatted: '+44  2890230938',
        website: 'www.harrycorry.com',
        county: 'Antrim',
        postcode: 'BT13 2BH',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.2732874491750055, 54.86167543031231],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Braidwater Retail Park, Larne Rd. Link, Ballymena, Co. Antrim, Antrim BT42 3ES',
        phone: '0044 2825636850',
        phoneFormatted: '+44  2825636850',
        website: 'www.harrycorry.com',
        county: 'Antrim',
        postcode: 'BT42 3ES',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.488065740654838, 54.77467186509789],
      },
      properties: {
        name: 'Mallusk Carpets & Beds',
        address:
          '16 Trench Rd, Mallusk, Newtownabbey, Co. Antrim, Antrim BT36 4TY',
        phone: '0044 28908 48686',
        phoneFormatted: '+44  28908 48686',
        website: '',
        county: 'Antrim',
        postcode: 'BT36 4TY',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.484032485831019, 54.7717104918999],
      },
      properties: {
        name: 'Martins Furnishings',
        address:
          'Unit 17, Twin Spires Centre, Northumberland St, Belfast, Co. Antrim, Antrim BT13 2JF',
        phone: '0044 28 90239431',
        phoneFormatted: '+44  28 90239431',
        website: '',
        county: 'Antrim',
        postcode: 'BT13 2JF',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.962426701898165, 54.5774295975515],
      },
      properties: {
        name: 'PMC Furniture',
        address:
          'Unit 1, 36-38 Boucher Rd, Belfast, Co. Antrim, Antrim BT12 6HR',
        phone: '0044 28 90406540',
        phoneFormatted: '+44  28 90406540',
        website: '',
        county: 'Antrim',
        postcode: 'BT12 6HR',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.819281686545619, 54.846171394726554],
      },
      properties: {
        name: "Rea's of Larne",
        address: '68 Bank Rd, Larne, Co. Antrim, Antrim BT40 3AN',
        phone: '0044 28 28260544',
        phoneFormatted: '+44  28 28260544',
        website: 'www.reasoflearne.org.uk',
        county: 'Antrim',
        postcode: 'BT40 3AN',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.924159544226115, 54.61315651122969],
      },
      properties: {
        name: 'Rite Price Furniture and Flooring',
        address: '220-258 York Street, Belfast, Co. Antrim, Antrim BT15 1GZ',
        phone: '0044 2890752777',
        phoneFormatted: '+44  2890752777',
        website: 'www.riteprice.co.uk',
        county: 'Antrim',
        postcode: 'BT15 1GZ',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.04411959510003, 54.51149575607507],
      },
      properties: {
        name: 'Smyth Patterson Ltd',
        address: '18 Market Square, Lisburn, Co. Antrim, Antrim BT28 1AF',
        phone: '0044 2892662707',
        phoneFormatted: '+44  2892662707',
        website: 'www.smythpatterson.co.uk',
        county: 'Antrim',
        postcode: 'BT28 1AF',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.512272463028185, 54.786054871463136],
      },
      properties: {
        name: 'Stylish Living at S&L Furniture',
        address: '82-86 Castlereagh Road, Belfast, Co. Antrim, Antrim BT5 5FR',
        phone: '0044 2890451414',
        phoneFormatted: '+44  2890451414',
        website: 'https://www.stylishlivingni.co.uk',
        county: 'Antrim',
        postcode: 'BT5 5FR',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.8096287490764595, 54.71646843361424],
      },
      properties: {
        name: 'TJ Warehouse Direct',
        address: '44 Albert Rd, Carrickfergus, Co. Antrim, Antrim BT3 88AE',
        phone: '0044 7501 709426',
        phoneFormatted: '+44  7501 709426',
        website: 'www.tjwarehousedirect.co.uk',
        county: 'Antrim',
        postcode: 'BT3 88AE',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.669167327615376, 54.326267780724685],
      },
      properties: {
        name: 'Dalzells of Markethill',
        address: '62-68 Main Street, Markethill, Co. Armagh, Armagh BT60 1PL',
        phone: '0044 2837551406',
        phoneFormatted: '+44  2837551406',
        website: 'www.dalzells.com',
        county: 'Armagh',
        postcode: 'BT60 1PL',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.390986899823569, 54.45211491192344],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          '2 Rushmere Shopping Centre 22, 2 Central Way, Craigavon, Co. Armagh, Armagh BT64 1AA',
        phone: '0044 2838346390',
        phoneFormatted: '+44  2838346390',
        website: 'www.harrycorry.com',
        county: 'Armagh',
        postcode: 'BT64 1AA',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.661192090488035, 54.344028210354026],
      },
      properties: {
        name: 'Martins Discount Stores Ltd',
        address: '25 Dobbin Street, Armagh, Co. Armagh, Armagh BT61 7QH',
        phone: '0044 28 37525805',
        phoneFormatted: '+44  28 37525805',
        website: '',
        county: 'Armagh',
        postcode: 'BT61 7QH',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.33150843869119, 54.46179182299227],
      },
      properties: {
        name: 'SD Kells',
        address:
          '59 Market Street, Lurgan, Craigavon, Co. Armagh, Armagh BT66 6AA',
        phone: '0044 2838 325358',
        phoneFormatted: '+44  2838 325358',
        website: '',
        county: 'Armagh',
        postcode: 'BT66 6AA',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.9268980017462605, 52.83207453693804],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Unit 2, Carlow Retail Park, Hanover Road, Co. Carlow, Carlow R93 C9F9',
        phone: '059 9138680',
        phoneFormatted: '059 9138680',
        website: 'www.harrycorry.com',
        county: 'Carlow',
        postcode: 'R93 C9F9',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.9530033625705645, 52.8416076698489],
      },
      properties: {
        name: 'Murphy Furniture',
        address: 'Unit 4, Shamrock Business Park, Co. Carlow, Carlow R93KP86',
        phone: '059 9173105',
        phoneFormatted: '059 9173105',
        website: 'www.murphysfurniture.ie',
        county: 'Carlow',
        postcode: 'R93KP86',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.971526886524669, 53.91744982274941],
      },
      properties: {
        name: "Clarke's of Bailieborough",
        address: 'Main Street, Bailieborough, Co. Cavan, Cavan A82 FN51',
        phone: '042 9665423',
        phoneFormatted: '042 9665423',
        website: 'www.clarkesbailieborough.ie',
        county: 'Cavan',
        postcode: 'A82 FN51',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.360749994605027, 54.00979511386972],
      },
      properties: {
        name: 'CP Furniture Sales',
        address: 'Eighter, Virginia, Co. Cavan, Cavan A83 W1H1',
        phone: '049 8547605',
        phoneFormatted: '049 8547605',
        website: 'www.cpfurnituresales.ie',
        county: 'Cavan',
        postcode: 'A83 W1H1',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.348722380789556, 53.98377122057009],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Unit 5 Cavn Retail Park, Dublin Road, Co. Cavan, Cavan H12 X295',
        phone: '049 4331037',
        phoneFormatted: '049 4331037',
        website: 'www.harrycorry.com',
        county: 'Cavan',
        postcode: 'H12 X295',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.984830028958696, 52.84420089374306],
      },
      properties: {
        name: 'Home Trends Furniture',
        address: '29-31 Parnell Street, Ennis, Co. Clare, Clare V95 ED79',
        phone: '065 6797853',
        phoneFormatted: '065 6797853',
        website: 'www.hometrendsfurniture.ie',
        county: 'Clare',
        postcode: 'V95 ED79',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.26773674430452, 51.549382590937796],
      },
      properties: {
        name: 'Abbey Furniture',
        address: '2 Bridge St, Coronea, Skibbereen, Co. Cork, Cork P81 W958',
        phone: '028 22131',
        phoneFormatted: '028 22131',
        website: '',
        county: 'Cork',
        postcode: 'P81 W958',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.461964198851483, 51.89435304499268],
      },
      properties: {
        name: 'Carrigaline Furniture & Carpets',
        address:
          'Old Pottery Complex, Carrigaline West Co. Cork, Cork P43 HE16',
        phone: '021 4919466',
        phoneFormatted: '021 4919466',
        website: 'www.carrigalinefunritureandcarpets.ie',
        county: 'Cork',
        postcode: 'P43 HE16',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.470017382277655, 51.876823953281125],
      },
      properties: {
        name: 'Crown Furniture',
        address: 'Garrienderk South, Charleville, Co. Cork, Cork V35 XF70',
        phone: '063 81782',
        phoneFormatted: '063 81782',
        website: 'www.crownfurniture.ie',
        county: 'Cork',
        postcode: 'V35 XF70',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.6542537, 52.1376965],
      },
      properties: {
        name: 'Dan Joe Fitzgerald Mallow Ltd',
        address: '13 West End, Mallow, Co. Cork, Cork P51 TDK8',
        phone: '022 22432',
        phoneFormatted: '022 22432',
        website: 'www.danjoefitzgerald.com',
        county: 'Cork',
        postcode: 'P51 TDK8',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.2737185, 52.1386911],
      },
      properties: {
        name: 'Denis O Mahony (Fermoy) Ltd',
        address: "O'Neill Crowley Quay, Fermoy, Co. Cork, Cork P61 KF65",
        phone: '025 31656',
        phoneFormatted: '025 31656',
        website: '',
        county: 'Cork',
        postcode: 'P61 KF65',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.48012192144314, 51.88814522739089],
      },
      properties: {
        name: 'Glentree Furniture',
        address: 'Brookpark, Clonakilty Rd, Dunmanway, Co. Cork, Cork P47 VW95',
        phone: '023 8856666',
        phoneFormatted: '023 8856666',
        website: 'www.glentreefurniture.ie',
        county: 'Cork',
        postcode: 'P47 VW95',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.669746801995505, 52.23395239971365],
      },
      properties: {
        name: 'Healy furniture & Carpets',
        address: 'Main Street, Buttevant, Co. Cork, Cork P51 DW01',
        phone: '022 23293',
        phoneFormatted: '022 23293',
        website: 'www.healyfurniture.ie',
        county: 'Cork',
        postcode: 'P51 DW01',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.485704014741636, 51.90590492412847],
      },
      properties: {
        name: 'House Of McGregor',
        address: 'Lissarda, Crookstown, Co. Cork, Cork P14 E985',
        phone: '021 7335680',
        phoneFormatted: '021 7335680',
        website: 'www.houseofmcgregor.ie',
        county: 'Cork',
        postcode: 'P14 E985',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.9104925, 51.6514159],
      },
      properties: {
        name: 'J & D Wiseman Ltd',
        address: 'Castletownbere, Co. Cork, Cork P75 NV08',
        phone: '027 70043',
        phoneFormatted: '027 70043',
        website: '',
        county: 'Cork',
        postcode: 'P75 NV08',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.46607564341993, 51.88556752592352],
      },
      properties: {
        name: 'Kelly & Co Bantry',
        address:
          'Bantry Business Park, Cork Road, Bantry, Co. Cork, Cork P75 XN20',
        phone: '027 50004',
        phoneFormatted: '027 50004',
        website: '',
        county: 'Cork',
        postcode: 'P75 XN20',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.2378442, 52.2595145],
      },
      properties: {
        name: 'Larry O Keeffe',
        address: 'Mitchelstown, Co. Cork, Cork P67 YF62',
        phone: '025 84424',
        phoneFormatted: '025 84424',
        website: 'www.larryokeeffe.com',
        county: 'Cork',
        postcode: 'P67 YF62',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.476742327847155, 51.88503733211293],
      },
      properties: {
        name: 'Lucey Furnishings',
        address: 'Unit 6, Millenium Court, Youghal, Co. Cork, Cork P36 Y959',
        phone: '024 92176',
        phoneFormatted: '024 92176',
        website: 'www.luceyfurnishings.ie',
        county: 'Cork',
        postcode: 'P36 Y959',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.4267114, 51.9150344],
      },
      properties: {
        name: 'Marlboro Trust',
        address: 'Mayfield Business Park, Mayfield, Co. Cork, Cork T23 WFD7',
        phone: '021 4504555',
        phoneFormatted: '021 4504555',
        website: 'www.marlborotrust.ie',
        county: 'Cork',
        postcode: 'T23 WFD7',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.8496925, 51.9552063],
      },
      properties: {
        name: 'Maxgrove Furniture',
        address: '32 North Main Street, Youghal, Co. Cork, Cork P36 VX57',
        phone: '024 93342',
        phoneFormatted: '024 93342',
        website: '',
        county: 'Cork',
        postcode: 'P36 VX57',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.451164486923346, 51.88772061044362],
      },
      properties: {
        name: 'McCauls of Millstreet',
        address: 'Church Street, Millstreet, Co. Cork, Cork P51 V489',
        phone: '029 70111',
        phoneFormatted: '029 70111',
        website: '',
        county: 'Cork',
        postcode: 'P51 V489',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.999037506747054, 52.214938975496366],
      },
      properties: {
        name: 'O Flynn and Tobin',
        address: 'Newmarket, Co. Cork, Cork P51 Y229',
        phone: '029 60572',
        phoneFormatted: '029 60572',
        website: '',
        county: 'Cork',
        postcode: 'P51 Y229',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.26876972020541, 51.56034798428175],
      },
      properties: {
        name: "Sean O'Driscoll Furniture",
        address:
          '14 Curragh Commercial park, Marsh Rd, Skibbereen, Co. Cork, Cork P81 HR29',
        phone: '028 51400',
        phoneFormatted: '028 51400',
        website: 'www.westcorkfurniture.ie',
        county: 'Cork',
        postcode: 'P81 HR29',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.64224993083479, 52.1370078295335],
      },
      properties: {
        name: 'Sugrues Furniture',
        address: "24 William O'Brien Street, Mallow, Co. Cork, Cork P51 TD43",
        phone: '022 22101',
        phoneFormatted: '022 22101',
        website: '',
        county: 'Cork',
        postcode: 'P51 TD43',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.4739823, 51.9084942],
      },
      properties: {
        name: 'The Furniture Centre',
        address: '14-16 Watercourse Rd, Blackpool, Co. Cork, Cork T23 N7TN',
        phone: '021 4503041',
        phoneFormatted: '021 4503041',
        website: 'www.thefurniturecentre.ie',
        county: 'Cork',
        postcode: 'T23 N7TN',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.471382428082467, 51.900965858213475],
      },
      properties: {
        name: 'The Loft Furniture Superstore',
        address: 'Peters Market, Cornmarket St Centre, Co. Cork, Cork',
        phone: '021 4274044',
        phoneFormatted: '021 4274044',
        website: 'www.theloftsuperstore.ie',
        county: 'Cork',
        postcode: '',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.88799464619696, 51.6229822319046],
      },
      properties: {
        name: 'Tom Sheehy & Co Ltd',
        address: 'Astna St, Scartagh, Clonakilty, Co. Cork, Cork P85 RC92',
        phone: '023 8833362',
        phoneFormatted: '023 8833362',
        website: '',
        county: 'Cork',
        postcode: 'P85 RC92',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.464089406812942, 51.92267151334551],
      },
      properties: {
        name: 'Top Drawer',
        address:
          'Unit B9, Fota Retail Park, Carrigtwohill, Co Cork, Cork T45A248',
        phone: '021 4389865',
        phoneFormatted: '021 4389865',
        website: 'www.topdrawer.ie',
        county: 'Cork',
        postcode: 'T45A248',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.908026372960181, 51.61775170366079],
      },
      properties: {
        name: 'West Cork Carpets',
        address: 'The Miles, Clonakilty, Co. Cork, Cork P85 YK44',
        phone: '023 8834113',
        phoneFormatted: '023 8834113',
        website: 'www.westcorkcarpets.ie',
        county: 'Cork',
        postcode: 'P85 YK44',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.304665060914905, 55.031460093029565],
      },
      properties: {
        name: 'Bradleys Furniture',
        address: '60 Aughrim Rd, Magherafelt, Londonderry, Derry BT45 6JY',
        phone: '0044 28 79632627',
        phoneFormatted: '+44  28 79632627',
        website: '',
        county: 'Derry',
        postcode: 'BT45 6JY',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.28942035359996, 54.98723869678567],
      },
      properties: {
        name: 'CFC Interiors',
        address: '75A Clooney Rd, Campsie, Co. Derry, Derry BT47 3PA',
        phone: '0044 2871860708',
        phoneFormatted: '+44  2871860708',
        website: 'www.beds.ie',
        county: 'Derry',
        postcode: 'BT47 3PA',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.32204453558235, 55.001072426709726],
      },
      properties: {
        name: 'Quayside Interiors',
        address:
          'Unit 7 Quayside Shopping Centre, Strand Rd, Londonderry, Co. Derry, Derry BT48 7PX',
        phone: '0044 2871260487',
        phoneFormatted: '+44  2871260487',
        website: 'www.quaysideinteriors.co.uk',
        county: 'Derry',
        postcode: 'BT48 7PX',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.9272298748899, 55.051302475674774],
      },
      properties: {
        name: 'Quayside Interiors',
        address:
          'Unit 5 Rathbuan Business Park, Limavady, Co. Derry, Derry BT49 0PB',
        phone: '0044 2877762690',
        phoneFormatted: '+44  2877762690',
        website: 'www.quaysideinteriors.co.uk',
        county: 'Derry',
        postcode: 'BT49 0PB',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.334738201879542, 55.01716844540443],
      },
      properties: {
        name: "Ryan's Carpets and Furniture",
        address: 'Springtown Ave, Co. Derry, Derry BT48 0LY',
        phone: '0044 2871263775',
        phoneFormatted: '+44  2871263775',
        website: '',
        county: 'Derry',
        postcode: 'BT48 0LY',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.7082992, 54.9707989],
      },
      properties: {
        name: 'Grove Furnishings',
        address: 'Lisnenan, Letterkenny, Co. Donegal, Donegal F92 YW83',
        phone: '074 9121064',
        phoneFormatted: '074 9121064',
        website: 'www.grovefurnishings.ie',
        county: 'Donegal',
        postcode: 'F92 YW83',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.454618, 55.1356174],
      },
      properties: {
        name: 'Hegartys Home Interiors',
        address: '55-60 Upper Main St, Buncrana, Co. Donegal, Donegal F93DD40',
        phone: '074 9361075',
        phoneFormatted: '074 9361075',
        website: 'www.hegartys.ie',
        county: 'Donegal',
        postcode: 'F93DD40',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.511813800040946, 54.81711143703755],
      },
      properties: {
        name: 'Pattersons Kitchens & Interiors',
        address: 'The Haw, Lifford, Co. Donegal, Donegal F93 X522',
        phone: '074 914 1985',
        phoneFormatted: '074 914 1985',
        website: 'www.pattersonskitchens.ie',
        county: 'Donegal',
        postcode: 'F93 X522',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.106364435288683, 54.65955316221109],
      },
      properties: {
        name: 'Stockhouse Interiors',
        address: 'Unit 7, Donegal Business Park, Co. Donegal, Donegal F94 N66E',
        phone: '074 9725367',
        phoneFormatted: '074 9725367',
        website: 'www.stockhouseinteriors.com',
        county: 'Donegal',
        postcode: 'F94 N66E',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.877188880842302, 54.35122097802959],
      },
      properties: {
        name: 'Derrylecka Bedding & Furniture Centre',
        address: 'Derrylacka Rd, Newry, Co. Down, Down BT34 2NJ',
        phone: '0044 8230851813',
        phoneFormatted: '+44  8230851813',
        website: 'www.derryleckabedding.com',
        county: 'Down',
        postcode: 'BT34 2NJ',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.046400503529803, 54.50774812907777],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Unit 1, 31-33 Hillsborough Rd., Lisburn, Co. Down, Down BT28 1JL',
        phone: '0044 2892660370',
        phoneFormatted: '+44  2892660370',
        website: 'www.harrycorry.com',
        county: 'Down',
        postcode: 'BT28 1JL',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.722261083944817, 54.32449106705355],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Unit 5, Downe Retail Park, 11 Ballydugan Road, Downpatrick, Co. Down, Down BT30 6DR',
        phone: '0044 2844839610',
        phoneFormatted: '+44  2844839610',
        website: 'www.harrycorry.com',
        county: 'Down',
        postcode: 'BT30 6DR',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.6569028305059135, 54.645377766879136],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Lesley Bloomfield Shopping Centre, S Circular Road, Bangor, Co. Down, Down BT19 7HR',
        phone: '0044 2891273291',
        phoneFormatted: '+44  2891273291',
        website: 'www.harrycorry.com',
        county: 'Down',
        postcode: 'BT19 7HR',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.684263407698607, 54.64636238375359],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Unit 6, Clandeboye Retail Park, W Circular Road, Bangor, Co. Down, Down BT19 1AR',
        phone: '0044 2891240361',
        phoneFormatted: '+44  2891240361',
        website: 'www.harrycorry.com',
        county: 'Down',
        postcode: 'BT19 1AR',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.337505315180577, 54.17677379984144],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address: '88 Hill Street 52, Newry, Co. Down, Down BT34 1BT',
        phone: '0044 283026 6765',
        phoneFormatted: '+44  283026 6765',
        website: 'www.harrycorry.com',
        county: 'Down',
        postcode: 'BT34 1BT',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.856449633277731, 54.32005442345316],
      },
      properties: {
        name: 'Herrons Furniture',
        address: '2 Hogstown Rd, Donaghadee, Co. Down, Down BT21 ONL',
        phone: '0044 28 91889181',
        phoneFormatted: '+44  28 91889181',
        website: 'www.herronsofdonaghadee.co.uk',
        county: 'Down',
        postcode: 'BT21 ONL',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.877508530351197, 54.33401504177325],
      },
      properties: {
        name: 'James Knox and Sons Ltd',
        address: '40 Newcastle Street, Kilkee, Co. Down, Down BT34 4AF',
        phone: '0044 28 41762406',
        phoneFormatted: '+44  28 41762406',
        website: '',
        county: 'Down',
        postcode: 'BT34 4AF',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.8815958526745735, 54.34479784284769],
      },
      properties: {
        name: 'Lisnasure Home Store',
        address: '43 Lisnasure Rd, Dromore, Co. Down, Down BT25 1JH',
        phone: '0044 28 38881628',
        phoneFormatted: '+44  28 38881628',
        website: 'www.lisnasurehome.com',
        county: 'Down',
        postcode: 'BT25 1JH',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.878868290118674, 54.32943434066964],
      },
      properties: {
        name: 'McCracken Carpets',
        address:
          'Dunlop Commercial Park 1, Ballyloo Link, Bangor, Co. Down, Down BT19 7HJ',
        phone: '0044 2891273057',
        phoneFormatted: '+44  2891273057',
        website: '',
        county: 'Down',
        postcode: 'BT19 7HJ',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.844187902610837, 54.31943353468757],
      },
      properties: {
        name: 'McCully Furnishings',
        address: '5 Conway Square, Newtownards, Co. Down, Down BT23 4DA',
        phone: '0044 2891225440',
        phoneFormatted: '+44  2891225440',
        website: '',
        county: 'Down',
        postcode: 'BT23 4DA',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.865340581795974, 54.33001930902081],
      },
      properties: {
        name: 'McCully Furnishings',
        address: '190 Rathgael Rd, Bangor, Co. Down, Down BT19 1RT',
        phone: '0044 28 91270100',
        phoneFormatted: '+44  28 91270100',
        website: '',
        county: 'Down',
        postcode: 'BT19 1RT',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.269582230743086, 54.349208597313336],
      },
      properties: {
        name: 'Porters of Banbridge',
        address: '11-13 Bridge Street, Banbridge, Co. Down, Down BT32 3JL',
        phone: '0044 2840662428',
        phoneFormatted: '+44  2840662428',
        website: 'www.porters-banbridge.co.uk',
        county: 'Down',
        postcode: 'BT32 3JL',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-5.865355469319538, 54.32548751649146],
      },
      properties: {
        name: 'Richbrook Furniture Bessbrook',
        address: 'Mill Rd, Newry, Co. Down, Down BT35 7DT',
        phone: '0044 7858571651, 00442830830153',
        phoneFormatted: '+44  7858571651, +44 2830830153',
        website: '',
        county: 'Down',
        postcode: 'BT35 7DT',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.16260118634167, 54.238040135052124],
      },
      properties: {
        name: 'Windsor Toal Carpets & Furniture',
        address: '12-18 New Street, Rathfriland, Co. Down, Down BT34 5PY',
        phone: '0044 2840630504',
        phoneFormatted: '+44  2840630504',
        website: '',
        county: 'Down',
        postcode: 'BT34 5PY',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.3529756, 53.3504156],
      },
      properties: {
        name: 'Dolphin Furniture Sales',
        address: 'Kylemore Rd, Ballyfermot, Dublin 10, Dublin D10 NY51',
        phone: '01 6262331',
        phoneFormatted: '01 6262331',
        website: 'www.dolphinfurniture.ie',
        county: 'Dublin',
        postcode: 'D10 NY51',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.267059306745339, 53.292439902812404],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Unit 7, Unit 7a Nutgrove Retail Park, Nutgrove Avenue, Dublin 14, Dublin D14 C9F6',
        phone: '01 4916990',
        phoneFormatted: '01 4916990',
        website: 'www.harrycorry.com',
        county: 'Dublin',
        postcode: 'D14 C9F6',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.392096886379255, 53.3487428575552],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Unit 11, Retail Park West, Liffey Valley, Fonthill Road, Liffey Valley Park, Dublin 22, Dublin D22 VY00',
        phone: '01 6215214',
        phoneFormatted: '01 6215214',
        website: 'www.harrycorry.com',
        county: 'Dublin',
        postcode: 'D22 VY00',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.226687759393134, 53.44632785889204],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Swords Central, Unit 3, Nass Road, Airside Retail Park, Swords, Co. Dublin, Dublin K67 EE97',
        phone: '01 9144047',
        phoneFormatted: '01 9144047',
        website: 'www.harrycorry.com',
        county: 'Dublin',
        postcode: 'K67 EE97',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.1801754, 53.6102806],
      },
      properties: {
        name: 'Hodgins Furnituer Balbriggan',
        address: 'Station St, Balbriggan, Fingal, Co. Dublin, Dublin K32 VX61',
        phone: '01 8412280',
        phoneFormatted: '01 8412280',
        website: 'www.hodginsfurniture.ie',
        county: 'Dublin',
        postcode: 'K32 VX61',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.24124208101048, 53.348442016687684],
      },
      properties: {
        name: 'Kingsbury Furniture',
        address:
          'Unit D1, Airton Business Park, Airton Rd, Tallaght, Dublin 24, Dublin D24 W974',
        phone: '01 4131354',
        phoneFormatted: '01 4131354',
        website: 'www.kingsburyfurntiure.ie',
        county: 'Dublin',
        postcode: 'D24 W974',
        country: 'Ireland',
        tags: ['comfort', 'origin'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.2371085, 53.4514961],
      },
      properties: {
        name: 'M.C.S. Carpets Swords',
        address: 'Unit 2, Forest rd, Swords, Co. Dublin, Dublin K67 DP73',
        phone: '01 8404933',
        phoneFormatted: '01 8404933',
        website: 'www.mcscarpets.ie',
        county: 'Dublin',
        postcode: 'K67 DP73',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.362998001951823, 53.29497776189463],
      },
      properties: {
        name: 'Murphys Furniture',
        address: '27 Broomhill Rd, Tallaght, Dublin 24, Dublin D24 W7RH',
        phone: '01 4525581',
        phoneFormatted: '01 4525581',
        website: 'www.murphysfurniture.ie',
        county: 'Dublin',
        postcode: 'D24 W7RH',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.657019959384592, 54.33727169186988],
      },
      properties: {
        name: 'Erneside Furniture',
        address:
          '26 Derrychara link, Enniskillen, Co. Fermanagh, Fermanagh BT74 6GB',
        phone: '0044 2866324438',
        phoneFormatted: '+44  2866324438',
        website: 'www.mattress.ie',
        county: 'Fermanagh',
        postcode: 'BT74 6GB',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.441810968676334, 54.2521643279967],
      },
      properties: {
        name: 'SD Kells',
        address:
          '164 Main Street, Lisnaskea, Co. Fermanagh, Fermanagh BT92 0JE',
        phone: '0044 2867 721229',
        phoneFormatted: '+44  2867 721229',
        website: '',
        county: 'Fermanagh',
        postcode: 'BT92 0JE',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.639782409860826, 54.346093394967184],
      },
      properties: {
        name: 'SD Kells',
        address: '9 Church St, Enniskillen, Co. Fermanagh, Fermanagh BT74 4RL',
        phone: '0044 2866 322567',
        phoneFormatted: '+44  2866 322567',
        website: '',
        county: 'Fermanagh',
        postcode: 'BT74 4RL',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.073286214753345, 53.264675094880886],
      },
      properties: {
        name: 'Better Bedding',
        address:
          'Mulvoy Park, 8 & 9  Sean Mulvoy Rd, Co. Galway, Galway H91 Y422',
        phone: '091 756766',
        phoneFormatted: '091 756766',
        website: 'www.betterbedding.ie',
        county: 'Galway',
        postcode: 'H91 Y422',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.5677472, 53.4879364],
      },
      properties: {
        name: 'Coppingers Furniture',
        address: 'Main St, Moylough, Co. Galway, Galway H53 NR24',
        phone: '0909 679274',
        phoneFormatted: '0909 679274',
        website: 'www.coppingersfurniture.com',
        county: 'Galway',
        postcode: 'H53 NR24',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.074520822303613, 53.26974213188334],
      },
      properties: {
        name: 'G Furniture',
        address:
          'North Point Retail Park, Tuam Rd, Co. Galway, Galway H91 Y2YT',
        phone: '091 753239',
        phoneFormatted: '091 753239',
        website: 'www.gfurniture.ie',
        county: 'Galway',
        postcode: 'H91 Y2YT',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.05108418081921, 53.28052909677751],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Galway Retail Park, Headford Road, Co. Galway, Galway H91 C3N1',
        phone: '091 509720',
        phoneFormatted: '091 509720',
        website: 'www.harrycorry.com',
        county: 'Galway',
        postcode: 'H91 C3N1',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.913969273102985, 53.61965604729483],
      },
      properties: {
        name: 'N17 Superstores',
        address:
          'Milltown Business Pk, Milltown, Tuam, Co. Galway, Galway H54 E096',
        phone: '093 51600',
        phoneFormatted: '093 51600',
        website: 'www.n17superstores.ie',
        county: 'Galway',
        postcode: 'H54 E096',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.016720849076455, 53.29382068072856],
      },
      properties: {
        name: 'N17 Superstores Galway City',
        address:
          'Unit 3 and 4 North Point, Tuam Rd, Co. Galway, Galway H917 W24',
        phone: '093 51600',
        phoneFormatted: '093 51600',
        website: 'www.n17superstores.ie',
        county: 'Galway',
        postcode: 'H917 W24',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.035784290407594, 53.26525528301217],
      },
      properties: {
        name: 'The Furniture Emporium',
        address:
          'Unit 10 Oranmore Business Park, Oranmore, Co. Galway, Galway H91 V298',
        phone: '091 788076',
        phoneFormatted: '091 788076',
        website: 'www.thefurnitureemporium.ie',
        county: 'Galway',
        postcode: 'H91 V298',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.796576459671412, 52.1044983601948],
      },
      properties: {
        name: 'Boyles of Killorglin',
        address: 'Laharn, Killorglin, Co. Kerry, Kerry V93 AV63',
        phone: '066 9761110',
        phoneFormatted: '066 9761110',
        website: 'www.boyles.ie',
        county: 'Kerry',
        postcode: 'V93 AV63',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.4859125, 52.4462776],
      },
      properties: {
        name: 'E J  Stack and Sons',
        address: '41 William Street, Listowel, Co. Kerry, Kerry V31 VX52',
        phone: '068 21639',
        phoneFormatted: '068 21639',
        website: '',
        county: 'Kerry',
        postcode: 'V31 VX52',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-10.2670121, 52.1408576],
      },
      properties: {
        name: 'Fitzgeralds Homevalue Hardware',
        address: 'Main Street, Dingle, Co. Kerry, Kerry V92 E5CY',
        phone: '066 9151177',
        phoneFormatted: '066 9151177',
        website: 'www.homevaluedingle.ie',
        county: 'Kerry',
        postcode: 'V92 E5CY',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.684455384178042, 52.18270513212348],
      },
      properties: {
        name: 'Hal Lou Furnishings',
        address:
          'Woodlawn Ind Park, Park Rd, Killarney, Co Kerry, Kerry V93 W7D2',
        phone: '064 6632401',
        phoneFormatted: '064 6632401',
        website: 'www.hal-loufurnishings.com',
        county: 'Kerry',
        postcode: 'V93 W7D2',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.5096949, 52.0597737],
      },
      properties: {
        name: 'Killarney Carpet & Furniture Centre',
        address: '46/47 High Street, Killarney, Co. Kerry, Kerry V93 K821',
        phone: '064 6631694',
        phoneFormatted: '064 6631694',
        website: 'www.killarneycarpetfurniturecentre.ie',
        county: 'Kerry',
        postcode: 'V93 K821',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.4664653, 52.2310624],
      },
      properties: {
        name: 'McElligotts',
        address: 'Tralee Rd, Castleisland, Co. Kerry, Kerry V92 V9FD',
        phone: '066 7141327',
        phoneFormatted: '066 7141327',
        website: 'www.mcelligotts.ie',
        county: 'Kerry',
        postcode: 'V92 V9FD',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.672472276853174, 52.26358506603568],
      },
      properties: {
        name: 'Tralee Furniture and Carpet Centre',
        address: 'Manor East, Tralee, Co. Kerry, Kerry V92 D799',
        phone: '066 7125455',
        phoneFormatted: '066 7125455',
        website: '',
        county: 'Kerry',
        postcode: 'V92 D799',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.894084119228992, 53.165124032672665],
      },
      properties: {
        name: 'Alan Conlon',
        address:
          'Alan Conlon, Unit 26C Newbridge Ind Estate, Newbridge, Co. Kildare, Kildare W13YE64',
        phone: '045 535705',
        phoneFormatted: '045 535705',
        website: '',
        county: 'Kildare',
        postcode: 'W13YE64',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.639359359402004, 53.23523847380987],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'The Globe Retail Park, Monreal Road, Maudlings, Naas, Co. Kildare, Kildare W91 X8F8',
        phone: '045 983170',
        phoneFormatted: '045 983170',
        website: 'www.harrycorry.com',
        county: 'Kildare',
        postcode: 'W91 X8F8',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.64072101544842, 53.23439260114609],
      },
      properties: {
        name: 'Murphy Furniture',
        address:
          'Unit 2, Monread Commercial Pk, Monread Rd, Naas, Co. Kildare, Kildare W91 PF83',
        phone: '045 898001',
        phoneFormatted: '045 898001',
        website: 'www.murphysfurniture.ie',
        county: 'Kildare',
        postcode: 'W91 PF83',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.2581199, 52.6482404],
      },
      properties: {
        name: 'Carpet Options',
        address: 'Walkin St, Co. Kilkenny, Kilkenny R95 CT96',
        phone: '056 7751744',
        phoneFormatted: '056 7751744',
        website: 'www.carpetoptionskilkenny.com',
        county: 'Kilkenny',
        postcode: 'R95 CT96',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.247350715245427, 52.63471006535191],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Unit 11, Kilkenny Retail Park, Co. Kilkenny, Kilkenny R95 C9RX',
        phone: '056 7712250',
        phoneFormatted: '056 7712250',
        website: 'www.harrycorry.com',
        county: 'Kilkenny',
        postcode: 'R95 C9RX',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.246774239139285, 52.67659072573014],
      },
      properties: {
        name: 'Meubles Furniture Store Kilkenny',
        address:
          'Unit 12, Kilkenny Business Park, Smithsland South, Co. Kilkenny, Kilkenny R95 Y26C',
        phone: '056 7797910',
        phoneFormatted: '056 7797910',
        website: 'www.meubles.ie',
        county: 'Kilkenny',
        postcode: 'R95 Y26C',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.172783700133924, 52.58755432967074],
      },
      properties: {
        name: "Treacy's Carpets & Furniture",
        address: 'Blackwell, Bennettsbridge, Co. Kilkenny, Kilkenny R95 PN77',
        phone: '056  7727193',
        phoneFormatted: '056  7727193',
        website: 'www.treacyscarpetsandfurniture.ie',
        county: 'Kilkenny',
        postcode: 'R95 PN77',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.285768818317301, 53.008940708772336],
      },
      properties: {
        name: 'Centre Point Carpets and Furniture',
        address:
          'Kylekiproe Ind Estate, Timahoe Rd, Portlaoise, Co. Laois, Laois R32 WR89',
        phone: '057 8620792',
        phoneFormatted: '057 8620792',
        website: 'www.centrepointcarpets.ie',
        county: 'Laois',
        postcode: 'R32 WR89',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.298808716072821, 53.00317558090703],
      },
      properties: {
        name: 'Cloud 9 Furntiure',
        address: 'Clonminam Ind Estate, Portlaoise, Co. Laois, Laois R32 PP30',
        phone: '057 8630296',
        phoneFormatted: '057 8630296',
        website: 'www.cloud9furniture.ie',
        county: 'Laois',
        postcode: 'R32 PP30',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.287470001737953, 53.02901557833329],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Unit 8, Portlaoise Retail Park, New Road, Borris Little, Portlaoise, Co. Laois, Laois R32 Y625',
        phone: '057 8670204',
        phoneFormatted: '057 8670204',
        website: 'www.harrycorry.com',
        county: 'Laois',
        postcode: 'R32 Y625',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.074896337017833, 54.02114632609041],
      },
      properties: {
        name: 'Carrick On Shannon Furniture World',
        address:
          'Boyle Rd, Tullyleague, Carrick On Shannon, Co. Leitrim, Leitrim N41 NY71',
        phone: '071 9672095',
        phoneFormatted: '071 9672095',
        website: '',
        county: 'Leitrim',
        postcode: 'N41 NY71',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.6356636, 52.6588433],
      },
      properties: {
        name: 'Chisel And Oak',
        address: "3 O'Curry Street, Co. Limerick, Limerick V94 R966",
        phone: '089 4171335',
        phoneFormatted: '089 4171335',
        website: '',
        county: 'Limerick',
        postcode: 'V94 R966',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.4724306, 52.3592022],
      },
      properties: {
        name: 'D J  Hayes and Co  Ltd',
        address: 'Kilfinane, Co. Limerick, Limerick V35 TR22',
        phone: '063 91151',
        phoneFormatted: '063 91151',
        website: '',
        county: 'Limerick',
        postcode: 'V35 TR22',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.594976586408217, 52.6573599697771],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Childers Retail Park, Unit 8, Childers Road, Co. Limerick, Limerick V94 X640',
        phone: '061 423260',
        phoneFormatted: '061 423260',
        website: 'www.harrycorry.com',
        county: 'Limerick',
        postcode: 'V94 X640',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.658979944080404, 52.66869140889753],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Ennis Road Retail Centre, Ennis Road, Coolraine, Co. Limerick, Limerick V94 X2F4',
        phone: '061 544130',
        phoneFormatted: '061 544130',
        website: 'www.harrycorry.com',
        county: 'Limerick',
        postcode: 'V94 X2F4',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.607564328907655, 52.68243310830561],
      },
      properties: {
        name: 'Limerick furntiure World',
        address:
          'Unit K2 Eastway Bus Park, Ballysimon Rd, Co. Limerick, Limerick V94 KA00',
        phone: '061 438500',
        phoneFormatted: '061 438500',
        website: '',
        county: 'Limerick',
        postcode: 'V94 KA00',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.63747393591, 52.66197773900442],
      },
      properties: {
        name: 'McElligotts Furniture and Carpets',
        address: 'Main Street, Abbeyfeale, Co. Limerick, Limerick V94 RR2K',
        phone: '068 31141',
        phoneFormatted: '068 31141',
        website: 'www.mcelligottfurnishings.com',
        county: 'Limerick',
        postcode: 'V94 RR2K',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.936527433842674, 52.522016850400604],
      },
      properties: {
        name: "Tadhg O'Connor Furniture & Electrical",
        address: 'New Line, Rathkeale, Co. Limerick, Limerick V94 NT99',
        phone: '069 63322',
        phoneFormatted: '069 63322',
        website: 'www.toc.ie',
        county: 'Limerick',
        postcode: 'V94 NT99',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.799271049674802, 53.718757593502104],
      },
      properties: {
        name: 'Longford Furniture World',
        address: 'Axis Business Park, Co. Longford, Longford N39 X291',
        phone: '043 3342531',
        phoneFormatted: '043 3342531',
        website: '',
        county: 'Longford',
        postcode: 'N39 X291',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.397078596936362, 53.93702700159623],
      },
      properties: {
        name: 'Cobra Beds & Furniture',
        address: 'Solmas, Louth Village, Co. Louth, Louth A91 TD74',
        phone: '042 9374766',
        phoneFormatted: '042 9374766',
        website: '',
        county: 'Louth',
        postcode: 'A91 TD74',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.392341461123943, 53.96439492267429],
      },
      properties: {
        name: 'Eddie Maguire Expert',
        address:
          '29  Church Street, Townparks, Dundalk, Co. Louth, Louth A91 DY66',
        phone: '042 9332043',
        phoneFormatted: '042 9332043',
        website: 'www.eddiemaguire.ie',
        county: 'Louth',
        postcode: 'A91 DY66',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.3813173, 53.9984963],
      },
      properties: {
        name: 'Franks Furniture Store Ltd',
        address: 'Coes Rd, Dundalk, Co. Louth, Louth A91 R894',
        phone: '042 9335026',
        phoneFormatted: '042 9335026',
        website: 'www.franksfurniture.ie',
        county: 'Louth',
        postcode: 'A91 R894',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.363651, 53.7059168],
      },
      properties: {
        name: 'Furniture Options',
        address:
          'Donore Industrial Estate, Donore Rd, Drogheda, Co. Louth, Louth A92 TYH3',
        phone: '041 9803777',
        phoneFormatted: '041 9803777',
        website: '',
        county: 'Louth',
        postcode: 'A92 TYH3',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.377784101697471, 53.99053955707336],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Dundalk Bay Retail Park, 8, Dundalk, Co. Louth, Louth A91 N227',
        phone: '042 9389420',
        phoneFormatted: '042 9389420',
        website: 'www.harrycorry.com',
        county: 'Louth',
        postcode: 'A91 N227',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.379737376193654, 53.70194877400949],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          '3 Drogheda Retail Park, Donore Road, Drogheda, Co. Louth, Louth A92 NX80',
        phone: '041 9809770',
        phoneFormatted: '041 9809770',
        website: 'www.harrycorry.com',
        county: 'Louth',
        postcode: 'A92 NX80',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.989696701588947, 54.2239169121899],
      },
      properties: {
        name: 'A J Reilly',
        address: 'Main Street, Belmullet, Co. Mayo, Mayo F26 N970',
        phone: '097 82982',
        phoneFormatted: '097 82982',
        website: '',
        county: 'Mayo',
        postcode: 'F26 N970',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.510333685206335, 53.76091463809123],
      },
      properties: {
        name: 'Carrowkeel Furniture',
        address: 'Turlough Rd, Carrowkeel, Castlebar, Co. Mayo, Mayo F23X437',
        phone: '094 9031522',
        phoneFormatted: '094 9031522',
        website: 'www.carrowkeelfurniture.com',
        county: 'Mayo',
        postcode: 'F23X437',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.9964728, 53.7129913],
      },
      properties: {
        name: 'M & S Carpets',
        address: 'Lakeside Retail Park, Claremorris, Co Mayo, Mayo F12 K096',
        phone: '094 9362608',
        phoneFormatted: '094 9362608',
        website: 'www.mandscarpets.ie',
        county: 'Mayo',
        postcode: 'F12 K096',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-9.171328959588237, 54.11458053934649],
      },
      properties: {
        name: 'N17 Superstores Ballina',
        address: 'Crossmolina Rd, Ballina, Co. Mayo, Mayo F26 A4X6',
        phone: '093 51600',
        phoneFormatted: '093 51600',
        website: 'www.n17superstores.ie',
        county: 'Mayo',
        postcode: 'F26 A4X6',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.5391866, 53.5125204],
      },
      properties: {
        name: 'Cosi Interiors',
        address: 'Main St Dunshaughlin, Co. Meath, Meath A85 YK77',
        phone: '01 8259865',
        phoneFormatted: '01 8259865',
        website: 'www.cosiinteriors.ie',
        county: 'Meath',
        postcode: 'A85 YK77',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.70075999918655, 53.65685541029066],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          '6 Blackwater Retail Park, Kells Road, Abbeyland South, Navan, Co. Meath, Meath C15 XN60',
        phone: '046 9084057',
        phoneFormatted: '046 9084057',
        website: 'www.harrycorry.com',
        county: 'Meath',
        postcode: 'C15 XN60',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.401564588226698, 53.51225127065001],
      },
      properties: {
        name: 'Patrick Warren Interiors',
        address:
          'Killegland Walk, Unit 64, Killegland St, Ashbourne, Co. Meath, Meath A84 FY05',
        phone: '01 2709773',
        phoneFormatted: '01 2709773',
        website: 'www.pwinteriors.ie',
        county: 'Meath',
        postcode: 'A84 FY05',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.696409059607903, 53.644323592826396],
      },
      properties: {
        name: 'Sherlock Interiors',
        address: 'Beechmount, Townparks, Navan, Co. Meath, Meath C15 WN56',
        phone: '046 9093544',
        phoneFormatted: '046 9093544',
        website: 'www.sherlockinteriors.ie',
        county: 'Meath',
        postcode: 'C15 WN56',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.791595288446839, 53.55693188272929],
      },
      properties: {
        name: 'Trim Furniture Craft',
        address:
          'Mill Street, Townparks North, Trim, Co. Meath, Meath C15 AW99',
        phone: '046 9436086',
        phoneFormatted: '046 9436086',
        website: 'www.trimfurniture.ie',
        county: 'Meath',
        postcode: 'C15 AW99',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.949105325528508, 54.25442118974087],
      },
      properties: {
        name: 'Drumbriston The Sofa Maker',
        address: 'Latlurcan, Monaghan, Co. Monaghan, Monaghan H18 K232',
        phone: '047 75122',
        phoneFormatted: '047 75122',
        website: 'www.drumbristonthesofamaker.com',
        county: 'Monaghan',
        postcode: 'H18 K232',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.722624, 53.9869671],
      },
      properties: {
        name: 'Killarue Interiors',
        address:
          'Ballybay Road, Carrickmacross, Co. Monaghan, Monaghan A81 V091',
        phone: '042 9661257',
        phoneFormatted: '042 9661257',
        website: 'www.killarueinteriors.ie',
        county: 'Monaghan',
        postcode: 'A81 V091',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.967792615406036, 54.25012967053327],
      },
      properties: {
        name: 'Starlighting Interiors',
        address: '29-30 Glaslough St, Roosky, Co. Monaghan, Monaghan H18 NX47',
        phone: '047 82867',
        phoneFormatted: '047 82867',
        website: '',
        county: 'Monaghan',
        postcode: 'H18 NX47',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.967269044241223, 54.25262559920468],
      },
      properties: {
        name: 'Upstairs Downstairs Monaghan',
        address: 'North Rd, Kilnacloy, Co. Monaghan, Monaghan H18 T026',
        phone: '047 72244',
        phoneFormatted: '047 72244',
        website: 'www.upstairsdownstairs.ie',
        county: 'Monaghan',
        postcode: 'H18 T026',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.469700333762016, 53.2671726391568],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'C Tullamore Retail Park, Portarlington Road, Cloncollog, Tullamore, Co. Offaly, Offaly R35 XD70',
        phone: '057 9320200',
        phoneFormatted: '057 9320200',
        website: 'www.harrycorry.com',
        county: 'Offaly',
        postcode: 'R35 XD70',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.9888179, 53.1913957],
      },
      properties: {
        name: 'Home Comforts',
        address: 'Main Street, Birr, Co. Offaly, Offaly R42 F897',
        phone: '057 9121600',
        phoneFormatted: '057 9121600',
        website: '',
        county: 'Offaly',
        postcode: 'R42 F897',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.1861226, 53.6290808],
      },
      properties: {
        name: "Ganly's of Athlone",
        address: 'Roscommon Rd, Athlone, Co. Roscommon, Roscommon N37 K303',
        phone: '0906 435300',
        phoneFormatted: '0906 435300',
        website: 'www.ganlys.ie',
        county: 'Roscommon',
        postcode: 'N37 K303',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.188901479468363, 53.60559675259005],
      },
      properties: {
        name: 'McNultys Furniture Roscommon',
        address:
          'Golf Links Rd, Ballypheasan, Co. Roscommon, Roscommon F42 CX71',
        phone: '0906 625657',
        phoneFormatted: '0906 625657',
        website: 'www.mcnultysfurniture.com',
        county: 'Roscommon',
        postcode: 'F42 CX71',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.4708590212513, 54.249795908005936],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Unit 10, Sligo retail Park, Carraroe, Carraroe, Co. Sligo, Sligo F91 N021',
        phone: '071 9151420',
        phoneFormatted: '071 9151420',
        website: 'www.harrycorry.com',
        county: 'Sligo',
        postcode: 'F91 N021',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.2003824, 52.8632791],
      },
      properties: {
        name: 'Abbey Furniture',
        address: 'Ormond Street, Nenagh, Co. Tipperary, Tipperary E45 HC53',
        phone: '0504 31700',
        phoneFormatted: '0504 31700',
        website: 'www.abbeyfurniture.ie',
        county: 'Tipperary',
        postcode: 'E45 HC53',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.179528930383992, 52.4568410893782],
      },
      properties: {
        name: 'Arramount Furniture Nenagh Ltd',
        address:
          'Unit 5, Springford Retail Park, Nenagh, Co. Tipperary, Tipperary E45 H398',
        phone: '067 64440',
        phoneFormatted: '067 64440',
        website: 'www.arramount.ie',
        county: 'Tipperary',
        postcode: 'E45 H398',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.151714515019085, 52.47299507847679],
      },
      properties: {
        name: 'Carrick Carpets',
        address:
          'Unit 2 Knocknagow, Nth Quay, Carrick On Suir, Co. Tipperary, Tipperary E32 XY68',
        phone: '051 645511',
        phoneFormatted: '051 645511',
        website: '',
        county: 'Tipperary',
        postcode: 'E32 XY68',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.8207042, 52.6734791],
      },
      properties: {
        name: 'Hanafins Furniture Stores',
        address:
          'Thurles Retail Park, Thurles, Co. Tipperary, Tipperary E41 NA48',
        phone: '0504 21144',
        phoneFormatted: '0504 21144',
        website: 'www.hanafins.ie',
        county: 'Tipperary',
        postcode: 'E41 NA48',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.168630051703653, 52.4638072486524],
      },
      properties: {
        name: 'Homeline Furniture',
        address: 'David Rd, Clonmel, Co. Tipperary, Tipperary E91 D580',
        phone: '052 6121853',
        phoneFormatted: '052 6121853',
        website: 'www.homelinefurniture.ie',
        county: 'Tipperary',
        postcode: 'E91 D580',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.693114966408248, 52.35443000093731],
      },
      properties: {
        name: "Larry O'Keeffe Furniture",
        address:
          'The Regal Centre, Davis Rd, Clonmel, Co. Tipperary, Tipperary E91 D580',
        phone: '052 6121853',
        phoneFormatted: '052 6121853',
        website: 'www.larryokeeffe.com',
        county: 'Tipperary',
        postcode: 'E91 D580',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.3884704, 52.6997138],
      },
      properties: {
        name: 'Nolan Carpets and Flooring Ltd',
        address: 'Newport, Co. Tipperary, Tipperary V947898',
        phone: '061 373739',
        phoneFormatted: '061 373739',
        website: 'www.nolancarpetsandblinds.com',
        county: 'Tipperary',
        postcode: 'V947898',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.185393259656589, 52.46638197087847],
      },
      properties: {
        name: 'Tim Leahy furniture & Carpet Sales Ltd',
        address:
          'Galbally Road, Ballinalard, Co. Tipperary, Tipperary E34 HF54',
        phone: '062 33125',
        phoneFormatted: '062 33125',
        website: 'www.timleahyfurnitureandcarpets.com',
        county: 'Tipperary',
        postcode: 'E34 HF54',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.314313173651428, 54.62286096012818],
      },
      properties: {
        name: 'CD Electrics',
        address: '12 John Street, Dungannon, Co. Tyrone, Tyrone BT701ES',
        phone: '0044 2887750086',
        phoneFormatted: '+44  2887750086',
        website: 'www.cdelectrics.com',
        county: 'Tyrone',
        postcode: 'BT701ES',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.30869372085081, 54.60037605022394],
      },
      properties: {
        name: 'CFC Interiors',
        address: '73 Chruch St, Cookstown, Co. Tyrone, Tyrone BT80 8HT',
        phone: '0044 2886763319',
        phoneFormatted: '+44  2886763319',
        website: 'www.beds.ie',
        county: 'Tyrone',
        postcode: 'BT80 8HT',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.312462143998978, 54.59905053661893],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          '3 Retail Park, 3 Great Northern Road, Omagh, Co. Tyrone, Tyrone BT78 5GZ',
        phone: '0044 2882250193',
        phoneFormatted: '+44  2882250193',
        website: 'www.harrycorry.com',
        county: 'Tyrone',
        postcode: 'BT78 5GZ',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.2889525201429395, 54.61049224607438],
      },
      properties: {
        name: 'Henrys Carpets & Furniture',
        address: '36-42 Main St, Fintona, Omagh, Co Tyrone, Tyrone BT782AD',
        phone: '0044 28 8284 1952',
        phoneFormatted: '+44  28 8284 1952',
        website: '',
        county: 'Tyrone',
        postcode: 'BT782AD',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.377423030727541, 54.718032506698044],
      },
      properties: {
        name: 'Hood & Co Interiors',
        address:
          '29 Main Street, Newtownstewart, Omagh, Co. Tyrone, Tyrone BT78 4AD',
        phone: '0044 2881661216',
        phoneFormatted: '+44  2881661216',
        website: '',
        county: 'Tyrone',
        postcode: 'BT78 4AD',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.306857772838725, 54.629289295634656],
      },
      properties: {
        name: 'Joseph Harley Ltd',
        address: '34 Main St, Strabane, Co. Tyrone, Tyrone BT82 8AS',
        phone: '0044 2871382547',
        phoneFormatted: '+44  2871382547',
        website: '',
        county: 'Tyrone',
        postcode: 'BT82 8AS',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.313967697618915, 54.62258295298841],
      },
      properties: {
        name: 'McCulloughs Carpets & Beds',
        address: '48 Union Street, Cookstown, Co. Tyrone, Tyrone BT80 8NN',
        phone: '0044 28 86763382',
        phoneFormatted: '+44  28 86763382',
        website: '',
        county: 'Tyrone',
        postcode: 'BT80 8NN',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-8.007462973165904, 52.09390411648032],
      },
      properties: {
        name: 'Michael Cunningham Hardware',
        address: 'West Street, Tallow, Co. Waterford, Waterford P51 KP82',
        phone: '058 56265',
        phoneFormatted: '058 56265',
        website: '',
        county: 'Waterford',
        postcode: 'P51 KP82',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.332543928149611, 53.55128998814315],
      },
      properties: {
        name: 'Athlone Furniture World',
        address: 'Old Dublin Rd,  Athlone, Co. Westmeath, Westmeath N37 W27O',
        phone: '0906 470099',
        phoneFormatted: '0906 470099',
        website: 'www.athlonefurniture.ie',
        county: 'Westmeath',
        postcode: 'N37 W27O',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.311927044044172, 53.53302058491613],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Unit M, Lakepoint Retail and Business Park, Devlin Road, Mullingar Business Park, Mullinger, Co. Westmeath, Westmeath N91 X5WP.',
        phone: '0044 9335560',
        phoneFormatted: '+44  9335560',
        website: 'www.harrycorry.com',
        county: 'Westmeath',
        postcode: 'N91 X5WP.',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.894475901721888, 53.411794758035136],
      },
      properties: {
        name: 'Harry Corry Ltd',
        address:
          'Kilmartin N6 Centre, Dublin Road, Bunnahinly, Athlone, Co. Westmeath, Westmeath N37 H2H9',
        phone: '090 6424738',
        phoneFormatted: '090 6424738',
        website: 'www.harrycorry.com',
        county: 'Westmeath',
        postcode: 'N37 H2H9',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.336050678934238, 53.54136625182513],
      },
      properties: {
        name: 'Mullingar Furniture World',
        address:
          'Zone A, Mullingar Business Park, Mullingar, Co. Westmeath, Westmeath N91 H006',
        phone: '044 9331982',
        phoneFormatted: '044 9331982',
        website: '',
        county: 'Westmeath',
        postcode: 'N91 H006',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.475441483002954, 52.35335552946005],
      },
      properties: {
        name: 'Cedarwood',
        address:
          'Unit 11 + 12 Woodbine Bus Park, Newross Co. Wexford, Wexford Y34 AK11',
        phone: '051 425850',
        phoneFormatted: '051 425850',
        website: 'www.cedarwood.ie',
        county: 'Wexford',
        postcode: 'Y34 AK11',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.5778416, 52.5016347],
      },
      properties: {
        name: 'Cedarwood',
        address: '71-73 Ross Rd, Enniscorthy, Co. Wexford, Wexford Y21 R598',
        phone: '053 9230311',
        phoneFormatted: '053 9230311',
        website: 'www.cedarwood.ie',
        county: 'Wexford',
        postcode: 'Y21 R598',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.484743045897055, 52.36021627543631],
      },
      properties: {
        name: 'Dwyer Furniture',
        address: 'The Bridge, Goreybridge, Co. Wexford, Wexford Y25 EK73',
        phone: '053 9421640',
        phoneFormatted: '053 9421640',
        website: '',
        county: 'Wexford',
        postcode: 'Y25 EK73',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.2730252779117555, 52.6918311666821],
      },
      properties: {
        name: 'Murphy Furniture',
        address: 'Arklow Rd, Gorey, Co. Wexford, Wexford Y25 F8H3',
        phone: '053 9481856',
        phoneFormatted: '053 9481856',
        website: 'www.murphysfurniture.ie',
        county: 'Wexford',
        postcode: 'Y25 F8H3',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.490135315485829, 52.32651719852515],
      },
      properties: {
        name: 'Murphy Furniture',
        address:
          'Clonard Retail Pk, Clonard Little, Co. Wexford, Wexford Y35 XNX0',
        phone: '053 9143580',
        phoneFormatted: '053 9143580',
        website: 'www.murphysfurniture.ie',
        county: 'Wexford',
        postcode: 'Y35 XNX0',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.54361672897081, 52.54860150215638],
      },
      properties: {
        name: 'Slaneyside Furniture',
        address: 'Scarawalsh, Enniscorthy, Co. Wexford, Wexford Y21 HP57',
        phone: '053 9236530',
        phoneFormatted: '053 9236530',
        website: 'www.slaneyside.ie',
        county: 'Wexford',
        postcode: 'Y21 HP57',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.1293904, 53.1801418],
      },
      properties: {
        name: 'Flanagan Kerins Furniture Store',
        address: 'Unit 3 Bray Retail Park, Bray, Co. Wicklow, Wicklow A98 W985',
        phone: '01 2813338',
        phoneFormatted: '01 2813338',
        website: 'www.flanagankerins.ie',
        county: 'Wicklow',
        postcode: 'A98 W985',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.2206046123625045, 53.02021900278397],
      },
      properties: {
        name: 'Halpin Furniture Ltd',
        address:
          'Dock Rd, Tinahask Lower, Arklow, Co. Wicklow, Wicklow Y14 FN84',
        phone: '0402 39065',
        phoneFormatted: '0402 39065',
        website: 'www.halpinfurniture.ie',
        county: 'Wicklow',
        postcode: 'Y14 FN84',
        country: 'Ireland',
        tags: ['comfort', 'origin', 'premium'],
      },
    },
  ],
}
